'use client';
import { OPEN_COOKIE_SETTINGS_EVENT } from '@lib/analytics';
import { useEffect } from 'react';

/**
 * Listens for clicks on "Manage Cookies" links in the footer and dispatches a
 * custom event to open the cookie settings modal.
 *
 * The design system does not provide a built-in way to handle this, so we implement it here.
 *
 * Usage: Call `useFooterCookieListener()` in a component that renders the footer.
 */
export function useFooterCookieListener() {
  useEffect(() => {
    const abortController = new AbortController();

    document.addEventListener(
      'click',
      (event) => {
        const target = (event.target as Element).closest(
          'a[href^="#open-cookie-settings"]',
        );
        if (target) {
          event.preventDefault();
          window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
        }
      },
      { signal: abortController.signal, capture: true },
    );

    return () => abortController.abort();
  }, []);
}
